<template>
  <div class="flex items-center">
    <div class="flex-none pr-base md:pr-lg mb-0">
      <p
        data-test="start-label"
        class="text-black font-light font-16"
        aria-hidden="true"
      >
        {{ startLabel }}
      </p>
    </div>
    <div class="flex-grow relative h-2.5">
      <div class="h-2.5 w-full rounded-10 bg-hoverGray absolute top-0 left-0"></div>
      <div
        class="h-2.5 rounded-10 bg-primaryGradient absolute top-0 left-0"
        :style="{width: calculatedWidth}">
      </div>
    </div>
    <div class="flex-none pl-base md:pl-lg">
      <p
        data-test="end-label"
        class="text-black font-light font-16"
        aria-hidden="true"
      >
        {{ endLabel }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BarProgressStepper',
  props: {
    startLabel: {
      type: String,
      required: true,
    },
    endLabel: {
      type: String,
      required: true,
    },
    totalSteps: {
      type: Number,
      required: true,
    },
    currentStep: {
      type: Number,
      required: false,
      default() {
        return 0;
      },
    },
  },

  computed: {
    calculatedWidth() {
      return `${(this.currentStep / this.totalSteps) * 100 }%`;
    },
  },
};
</script>
